import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getPostList} from '../../../apis/post/getPostList'

const useQueryPostList = (search_word?: string, size?: number, currentPage: number = 1, search_id?: string) => {
    const PAGE_SIZE = size || 10
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.post.getPostList(search_word, currentPage),
        queryFn: async () => {
            const {data, pageInfo} = await getPostList(PAGE_SIZE, currentPage, search_word, search_id)
            return {data, pageInfo}
        },
    })
    return {data, refetch}
}

export default useQueryPostList
